import { useState } from "react";

export function useApiURL() {
  //const [url] = useState("http://localhost:14631");
  const [url] = useState("");
  return {
    url
  };
}
